import { useDocumentMeta } from "../hooks/useDocumentMeta";
import { LegalLayout } from "../components/LegalLayout";

export default function ConditionsUtilisation() {
  useDocumentMeta({
    title: "Conditions d'utilisation — FOD by DMB Partners",
    description: "Conditions générales d'utilisation du site FOD by DMB Partners : accès, contenu, propriété intellectuelle et responsabilités du visiteur et de l'éditeur.",
    canonical: "https://www.fodbydmb.com/conditions-utilisation",
  });
  return (
    <LegalLayout testid="cgu-page" title="Conditions d'utilisation" subtitle="Mises à jour le 06/12/2024.">
          <p>
            Il est impératif que tout Internaute prenne connaissance des présentes Conditions Générales
            d'Utilisation (ci-après désignées « CGU ») qui définissent les règles d'utilisation du présent
            site web.
          </p>
          <p>La simple utilisation du présent site web suppose l'acceptation pleine et entière des CGU.</p>

          <h2>Article 01. Définitions</h2>
          <p>Dans les CGU, les mots ou expressions commençant avec une majuscule ont la signification qui suit :</p>
          <ul>
            <li><strong>Internaute</strong> : toute personne qui visite une ou plusieurs pages du Site.</li>
            <li><strong>Site</strong> : le présent site web, notamment accessible à l'adresse suivante : <a href="https://www.fodbydmb.fr" target="_blank" rel="noreferrer">www.fodbydmb.fr</a></li>
          </ul>

          <h2>Article 02. Objet</h2>
          <p>Les CGU régissent l'accès et l'utilisation du Site.</p>
          <p>
            FOD se réserve le droit de modifier à tout moment les CGU en publiant une nouvelle version de ces
            dernières sur le Site. Ces modifications entreront en vigueur dès leur mise en ligne sur le Site
            et seront donc opposables à tout Internaute dès cet instant.
          </p>
          <p>
            Il est précisé que, dans les relations entre FOD et l'Internaute, les CGU régissent l'ensemble de
            leur relation contractuelle et s'appliquent à l'exclusion de toute autre convention.
          </p>
          <p>
            FOD conseille à toute personne visitant le Site de sauvegarder ou d'imprimer les CGU, sans
            toutefois les modifier.
          </p>

          <h2>Article 03. Demandes de contacts</h2>
          <p>
            L'Internaute peut contacter FOD en adressant un courrier électronique à l'adresse suivante :{" "}
            <a href="mailto:contact@fodbydmb.com">contact@fodbydmb.com</a>, ou en remplissant le formulaire
            prévu à cet effet à la rubrique « <a href="/contact">Contact</a> ».
          </p>
          <p>
            FOD fera ses meilleurs efforts pour répondre à toute demande de contact adressée par un Internaute
            dans les meilleurs délais. Toutefois FOD ne s'engage en aucun cas à apporter une réponse ni à
            accuser réception de la demande de l'Internaute, sauf si celle-ci concerne l'exercice d'un de ses
            droits relatifs au traitement de ses données à caractère personnel.
          </p>

          <h2>Article 04. Propriété intellectuelle</h2>
          <p>
            Le Site, son contenu et tous les éléments le constituant sont des créations pour lesquelles FOD
            est titulaire de l'intégralité des droits de propriété intellectuelle et/ou a obtenu des droits
            d'exploitation, en particulier au titre du droit d'auteur, du droit des dessins et modèles, du
            droit des bases de données, du droit des marques.
          </p>
          <p>
            Les marques verbales et semi-figuratives « FOD » sont des marques déposées. Toute utilisation de
            ces marques est interdite sans autorisation préalable et écrite de FOD.
          </p>
          <p>
            Le Site, ainsi que les logiciels, structures des bases de données, textes, informations, analyses,
            images, photographies, graphismes, logos, sons ou toutes autres données contenues sur le Site
            demeurent la propriété exclusive de FOD ou, le cas échéant, de leurs propriétaires respectifs avec
            qui FOD a conclu des accords d'utilisation.
          </p>
          <p>
            Ils ne peuvent en aucun cas être reproduits, utilisés ou représentés sans l'autorisation écrite
            et expresse de FOD, sous peine de poursuites judiciaires. Aux fins d'obtenir cette autorisation,
            il convient d'adresser un courrier électronique à :{" "}
            <a href="mailto:contact@fodbydmb.com">contact@fodbydmb.com</a>.
          </p>
          <p>
            FOD accorde à l'Internaute un droit d'utilisation, non exclusif et non transférable, du Site
            ainsi que des œuvres de l'esprit originales et données contenues sur le Site. Le droit ainsi
            concédé consiste en (i) un droit de consulter en ligne les œuvres de l'esprit originales et
            données contenues sur le Site et (ii) un droit de reproduction consistant en une impression et/ou
            une sauvegarde de ces œuvres de l'esprit originales et données consultées. Ce droit d'utilisation
            s'entend uniquement pour un usage strictement privé. Tout autre droit est expressément réservé
            par FOD.
          </p>
          <p>
            Toute autre utilisation du Site, notamment commerciale, de la part de l'Internaute est interdite
            sans l'autorisation écrite et expresse de FOD.
          </p>
          <p>
            L'Internaute s'interdit notamment, de manière non exhaustive, pour un usage autre que privé, de
            reproduire et/ou représenter, télécharger, vendre, distribuer, émettre, traduire, adapter,
            exploiter, distribuer, diffuser et communiquer intégralement ou partiellement sous quelque forme
            que ce soit, à titre commercial ou non, toute œuvre de l'esprit originale ou donnée contenue sur
            le Site.
          </p>
          <p>
            L'Internaute s'interdit également d'introduire des données sur le Site qui modifieraient ou qui
            seraient susceptibles de modifier le contenu ou l'apparence des données, de la présentation ou de
            l'organisation du Site ou des œuvres figurant sur le Site, et par quelque procédé que ce soit.
          </p>

          <h2>Article 05. Liens hypertextes</h2>
          <p>
            Tout lien hypertexte vers le Site, quel que soit le type de lien, doit faire l'objet d'une
            autorisation préalable de FOD, sur support papier ou électronique.
          </p>
          <p>
            Le Site peut inclure des liens hypertextes vers d'autres sites web ou ressources de l'internet
            externes au Site.
          </p>
          <p>
            Au jour de leur création, FOD s'est assurée, dans la mesure du possible, que ces sites web et
            autres ressources de l'internet ne comportaient pas de contenus contrevenant aux lois françaises.
          </p>
          <p>
            Cependant, dans la mesure où FOD ne peut contrôler en permanence ces sites et ces ressources
            externes, elle ne peut s'assurer que ces sites et ressources restent en permanence conformes aux
            exigences légales.
          </p>
          <p>
            En conséquence, FOD ne saurait être tenue pour responsable de la mise à disposition de ces sites
            et ressources externes que dans la mesure où la page ou ressource de l'internet vers laquelle un
            lien hypertexte a été créé comportait un contenu contrevenant aux lois françaises au moment de
            sa création.
          </p>
          <p>
            FOD ne peut donc supporter aucune responsabilité quant aux contenus, publicités, produits et
            services disponibles sur ou à partir de ces sites ou ressources externes proposés postérieurement
            à la création du lien hypertexte sur son Site.
          </p>

          <h2>Article 06. Gestion des données personnelles et cookies</h2>
          <p>
            FOD accorde une grande importance à la protection des données à caractère personnel et tient à
            assurer les Internautes que leur vie privée est protégée.
          </p>
          <p>
            Il convient de se référer à notre{" "}
            <a href="/politique-de-confidentialite">Politique de confidentialité</a> pour en savoir plus.
          </p>
          <p>
            FOD pourra aussi collecter de manière automatisée des informations concernant un Internaute à
            chacune de ses visites sur le Site par le biais de traceurs ou cookies. Pour plus d'informations
            sur les modalités de collecte de données personnelles dans ce cadre, il convient de se référer à
            notre <a href="/politique-de-confidentialite">Politique de confidentialité</a>.
          </p>

          <h2>Article 07. Responsabilité</h2>
          <p>
            FOD n'est responsable que du contenu des pages qu'elle édite, étant précisé que l'ensemble des
            annonces des Partenaires figurant sur le Site ne sont qu'hébergées, et non éditées, par FOD.
          </p>
          <p>
            FOD ne peut en aucun cas être tenue responsable de tout dommage susceptible d'intervenir sur le
            système informatique de l'Internaute et/ou de la perte de données résultant de l'utilisation du
            Site par l'Internaute.
          </p>
          <p>
            FOD ne saurait être tenue pour responsable pour d'autres faits que ceux relatifs à l'édition du
            Site. Elle ne garantit aucunement la disponibilité ou les performances du Site. La responsabilité
            de FOD ne peut être recherchée que pour faute prouvée et pour des dommages directs et prévisibles,
            exclusivement causés par un manquement de FOD à ses obligations.
          </p>
          <p>
            FOD ne saurait être tenue responsable du non-fonctionnement, d'une impossibilité d'accès ou de
            dysfonctionnements du Site imputables à un équipement non adapté, à des dysfonctionnements des
            services du fournisseur d'accès des Internautes, à ceux du réseau internet.
          </p>
          <p>
            En outre, l'Internaute reconnaît que les caractéristiques et les contraintes du réseau internet
            ne permettent pas de garantir la disponibilité et le bon fonctionnement du Site. À ce titre, il
            est précisé que :
          </p>
          <ul>
            <li>Le Site est normalement accessible 24 heures sur 24, 7 jours sur 7 sauf cas de force majeure ou événement hors du contrôle de FOD,</li>
            <li>FOD peut être amenée à interrompre l'accès à tout ou partie du Site, à tout ou partie des Internautes, de façon temporaire pour des raisons de maintenance visant le bon fonctionnement du Site, sans préavis et sans que cette interruption puisse donner droit à une quelconque indemnité pour l'Internaute.</li>
          </ul>

          <h2>Article 08. Loi applicable et attribution de compétence</h2>
          <p>
            Les CGU sont soumises au droit français, à l'exclusion de toute autre législation ou
            réglementation étrangère, quel que soit le pays dans lequel est implanté l'Internaute et/ou
            depuis lequel l'accès au Site est réalisé.
          </p>
          <p style={{ textTransform: "uppercase", fontSize: "0.85em" }}>
            S'agissant des Internautes ayant la qualité de commerçants, en cas de litige entre les parties
            découlant de la formation, l'interprétation, l'exécution et/ou la fin des CGU, et après une
            tentative de recherche d'une solution amiable, compétence expresse est attribuée au Tribunal de
            Commerce de Paris, nonobstant pluralité de défendeurs ou appel en garantie, même pour les
            procédures d'urgence ou les procédures conservatoires ou en référé ou par requête.
          </p>
    </LegalLayout>
  );
}
